import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CategoryAutocomplete from 'hui/dist/js/components/autocomplete/category-autocomplete';
import api from 'axios';
import memoize from 'lodash/memoize';

const fetchSuggestions = memoize(query =>
  api.get('/api/getquotes/categories', { params: { query } }));

export default class CategorySearch extends Component {
  static propTypes = { // eslint-disable-line
    classPrefix: PropTypes.string,
    value: PropTypes.string,
    placeholder: PropTypes.string
  };

  static defaultProps = { // eslint-disable-line 
    classPrefix: 'hero__gq-category',
    value: '',
    placeholder: 'E.g. Plumber, Electrician, Carpenter'
  };

  state = { // eslint-disable-line
    category: {}
  };

  onSelect = (category) => { // eslint-disable-line
    this.setState({ category });
  };

  render() {
    const { category } = this.state;
    return (
      <div>
        <CategoryAutocomplete
          value={this.props.value}
          classPrefix={this.props.classPrefix}
          data-placeholder={this.props.placeholder}
          placeholder={this.props.placeholder}
          onSelectCategory={this.onSelect}
          name="category"
          fetchSuggestions={fetchSuggestions}
        />
        <input
          type="hidden"
          className={`${this.props.classPrefix}-key`}
          value={category.key}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./get-quotes/scripts/components/getquotes-category-autocomplete.js